import { render, staticRenderFns } from "./SignUpSection.vue?vue&type=template&id=425edcee"
import script from "./SignUpSection.vue?vue&type=script&lang=js"
export * from "./SignUpSection.vue?vue&type=script&lang=js"
import style0 from "./SignUpSection.vue?vue&type=style&index=0&id=425edcee&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports